import autocomplete from 'autocompleter';
import './autocomplete.scss'
import {featureAutoSuggester} from "./featureAutoSuggester";
import type {AutoSuggesterResponseType} from "./featureAutoSuggester";

type InputType = 'text' | 'number' | 'datetime-local' | 'datetime' | 'date';

interface FilterInputTextProps {
    className?: string;
    value?: string;
    placeholder: string;
    maxLength?: number;
    db_autosuggest_column_name?: string;
}

interface FilterInputTextCallbacks {
    onChange: (value: string) => boolean;
    isValid?: (value: string) => boolean;
}

const FilterInputText = (inputType: InputType, props: FilterInputTextProps, callbacks: FilterInputTextCallbacks) => {

    let div = document.createElement('div') as HTMLDivElement;
    let isValid: boolean | null = null;
    let isDirty: boolean = false;

    const markError = (isValid: boolean) => {
        if (isDirty) {
            if (isValid) {
                div.classList.remove('filter-input-error');
                div.classList.add('filter-input-valid');
            } else {
                div.classList.add('filter-input-error');
                div.classList.remove('filter-input-valid');
            }
        }
    }

    // const removeMarks = () => {
    //     div.classList.remove('filter-input-error');
    //     div.classList.remove('filter-input-valid');
    // }

    let value_string: string = (typeof props.value !== 'string' ? String(props.value).trim() : props.value);
    // let value_string: string = props.value.trim() || '';

    div.innerHTML = `
        <input type="${inputType}" class="js-filter-input ${props?.className}" placeholder="${(props?.placeholder && props.placeholder || '')}" value="${value_string}" ${(props?.maxLength && props?.maxLength > 0 ? ` maxlength="${props?.maxLength}" ` : ``)}>
    `;
    
   
    interface AutoSuggesterDataInterface {
        label: string;
        value: string;
        group?: string;
    }
    //
    // const countries: AutoSuggesterDataInterface[] = [
    //     { label: 'Canada', value: 'CA' },
    //     { label: 'United States', value: 'US'},
    //     { label: 'Uzbekistan', value: 'UZ'},
    // ];
    
    // type AutoSuggesterDataInterface  = string[];
    
    // https://www.npmjs.com/package/autocompleter
    if (props.db_autosuggest_column_name && inputType === 'text') {
        autocomplete<AutoSuggesterDataInterface>({
            minLength: 1,
            input: div.querySelector('.js-filter-input') as HTMLInputElement,
            fetch: function (text: string, update: (items: AutoSuggesterDataInterface[]) => void) {
                console.log('autocomplete fetch', text, update);
                text = text.toLowerCase();
                featureAutoSuggester.getSuggestions({
                    fldName: props.db_autosuggest_column_name,
                    query: text,
                    maxItems: 10,
                }).then((response: AutoSuggesterResponseType) => {
                    let suggestions: AutoSuggesterDataInterface[] = [];
                    response.items.forEach(item => {
                        suggestions.push({
                            label: item,
                            value: item,
                        });
                    })
                    console.log('autocomplete getSuggestions', suggestions);
                    update(suggestions);
                }).catch((err) => {
                    console.error('autocomplete error', err);
                });
                // let suggestions = countries.filter(n => n.label.toLowerCase().startsWith(text))
                // update(suggestions);
            },
            onSelect: function (item: AutoSuggesterDataInterface) {
                // alert(item.value);
                console.log('autocomplete onSelect', item);
                let el = div.querySelector('.js-filter-input') as HTMLInputElement;
                if (el) el.value = item.label;
                callbacks.onChange(item.label);
            }
        });
    }

    const onChange = (e: Event) => {
        // e.StopPropagation();
        isValid = callbacks.onChange((e.target as HTMLInputElement).value.trim());
        isDirty = true;
        // if (typeof callbacks.isValid === 'function' && isValid === false) {
        //     isValid = callbacks.isValid((e.target as HTMLInputElement).value.trim());
        // }
        markError(isValid);
    }

    let input_element = div.querySelector('.js-filter-input') as HTMLInputElement;
    if (input_element) {
        // input_element.addEventListener('change', onChange);
        input_element.addEventListener('keyup', onChange);
        input_element.addEventListener('blur', (e) => {
            onChange(e);
            // removeMarks();
        });
    } else {
        throw new Error('FilterInputText: input element not found');
    }

    return {
        element: div,
        value: () => {
            return input_element.value.trim();
        },
        setValid(valid: boolean) {
            markError(valid);
        }
    }
}

export default FilterInputText;